import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { headerOperation, cellOperation } from 'helpers/tables';
import BaseTable from 'components/UI/BaseTable';

const STATUS_CLASSES = {
  Activo: 'ldap-status-activo',
  Deshabilitado: 'ldap-status-deshabilitado',
  Bloqueado: 'ldap-status-bloqueado',
};

const statusBadge = (status) => (
  <div className="text-center table-cell">
    <span className={`ldap-status-badge ${STATUS_CLASSES[status] || 'ldap-status-deshabilitado'}`}>
      {status || 'Desconocido'}
    </span>
  </div>
);

const formatDate = (value) => (value ? moment(value).format('DD-MM-YYYY HH:mm') : 'Nunca');

const LdapUsersTable = ({
  count, data, loading, onFetchData, pages, onFilteredChange,
}) => {
  const columns = [
    {
      Header: headerOperation('Usuario'),
      id: 'username',
      accessor: (i) => cellOperation(i.username),
      minWidth: 100,
    },
    {
      Header: headerOperation('Nombre completo'),
      id: 'full_name',
      accessor: (i) => cellOperation(i.full_name),
      minWidth: 140,
    },
    {
      Header: headerOperation('Email'),
      id: 'email',
      accessor: (i) => cellOperation(i.email),
      minWidth: 140,
    },
    {
      Header: headerOperation('Cargo'),
      id: 'job_title',
      accessor: (i) => cellOperation(i.job_title),
      minWidth: 100,
    },
    {
      Header: headerOperation('Departamento'),
      id: 'department',
      accessor: (i) => cellOperation(i.department),
      minWidth: 100,
    },
    {
      Header: headerOperation('Empresa'),
      id: 'company',
      accessor: (i) => cellOperation(i.company),
      minWidth: 100,
    },
    {
      Header: headerOperation('UPN'),
      id: 'user_principal_name',
      accessor: (i) => cellOperation(i.user_principal_name),
      minWidth: 140,
    },
    {
      Header: headerOperation('Estado'),
      id: 'account_status',
      accessor: (i) => statusBadge(i.account_status),
      minWidth: 90,
    },
    {
      Header: headerOperation('Último login'),
      id: 'last_logon',
      filterable: false,
      accessor: (i) => cellOperation(formatDate(i.last_logon)),
      minWidth: 120,
    },
    {
      Header: headerOperation('Fecha de creación'),
      id: 'when_created',
      filterable: false,
      accessor: (i) => cellOperation(formatDate(i.when_created)),
      minWidth: 120,
    },
    {
      Header: headerOperation('Última modificación'),
      id: 'when_changed',
      filterable: false,
      accessor: (i) => cellOperation(formatDate(i.when_changed)),
      minWidth: 120,
    },
  ];

  return (
    <div style={{ marginTop: '30px' }}>
      <BaseTable
        filterable
        resizable={false}
        loading={loading}
        data={data}
        columns={columns}
        showPagination
        resultCount={count}
        pages={pages}
        onFetchData={onFetchData}
        onFilteredChange={onFilteredChange}
      />
    </div>
  );
};

LdapUsersTable.propTypes = {
  count: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  pages: PropTypes.number.isRequired,
  onFetchData: PropTypes.func.isRequired,
  onFilteredChange: PropTypes.func.isRequired,
};

LdapUsersTable.defaultProps = {
  count: 0,
};

export default LdapUsersTable;
